import styled, { space } from '@styled'

export const StyledWrapper = styled(
  // eslint-disable-next-line no-unused-vars
  ({ p, px, py, pt, pb, pl, pr, m, mx, my, mt, mb, ml, mr, ...rest }) => (
    <div {...rest} />
  )
)`
  ${space};
`
